import { render, staticRenderFns } from "./detailFeedbackFoodClaim.vue?vue&type=template&id=70ddacde&"
import script from "./detailFeedbackFoodClaim.vue?vue&type=script&lang=js&"
export * from "./detailFeedbackFoodClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports